import { chakraComponents, GroupBase, OptionProps } from 'chakra-react-select';
import React from 'react';
import { SelectOption } from '../types';
import { IconWrapper } from './IconWrapper';

export const Option = (
  props: OptionProps<SelectOption, false, GroupBase<SelectOption>>
) => {
  const {
    innerProps,
    selectProps: { dataTestId, optionDataTestId },
    children,
    data,
  } = props;

  return (
    <chakraComponents.Option
      {...props}
      data={data}
      innerProps={
        {
          ...innerProps,
          'data-testid': optionDataTestId || `${dataTestId}-option`,
        } as OptionProps['innerProps']
      }
    >
      {data.icon && <IconWrapper icon={data.icon} />}
      {children}
    </chakraComponents.Option>
  );
};
